"use client";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import AuthContentWrapper from "./components/AuthContentWrapper";

export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AuthContentWrapper>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY as string}
        scriptProps={{
          async: true,
          defer: true,
          appendTo: "head",
        }}
      >
        {children}
      </GoogleReCaptchaProvider>
    </AuthContentWrapper>
  );
}
